<dialog class="youtube-video-overlay" #dialogEl>
  <div class="youtube-video-overlay__close-background" (click)="onClosed.emit(true)"></div>
  <button role="button" class="youtube-video-overlay__close-button" (click)="onClosed.emit(true)"><brt-icon [icon]="'x-thin'"></brt-icon></button>

  <div class="youtube-video-overlay__iframe">
    <brt-embed-video-youtube [youtube-str]="src" [object-fit]="'contain'"></brt-embed-video-youtube>
  </div>
</dialog>
